<template>
  <t-form labelWidth="100px">
    <t-form-item label="内边距(上)">
      <t-input-number v-model="attribute.paddingTop" size="small" :min="0" :max="600" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="内边距(右)">
      <t-input-number v-model="attribute.paddingRight" size="small" :min="0" :max="600" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="内边距(下)">
      <t-input-number v-model="attribute.paddingBottom" size="small" :min="0" :max="600" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="内边距(左)">
      <t-input-number v-model="attribute.paddingLeft" size="small" :min="0" :max="600" :decimal-places="0"/>
    </t-form-item>
  </t-form>
</template>

<script>
export default {
  name: "cpt-img-quota-tips-option",
  props: { attribute: Object },
}
</script>

<style scoped>

</style>